import { ReferralStatusIndicator } from '@strata/react-status-indicators';
import { type ComponentProps } from 'react';

const StatusTooltipMap: Partial<Record<keyof typeof ReferralStatusIndicator.Statuses, string>> = {
    [ReferralStatusIndicator.Statuses.PHARM]: 'Active referral that a pharmacy is servicing.',
    [ReferralStatusIndicator.Statuses.EXPIRED]: 'Referral is no longer active.',
    [ReferralStatusIndicator.Statuses.PENDREAUTH]:
        'The auth for this referral expires within 30 days.',
    [ReferralStatusIndicator.Statuses.DISCONTD]: 'Patient therapy was discontinued.',
} as const;

interface ApertureReferralStatusIndicatorProps {
    status?: ComponentProps<typeof ReferralStatusIndicator>['status'];
}

export const ApertureReferralStatusIndicator = ({
    status = undefined,
}: ApertureReferralStatusIndicatorProps) => (
    <ReferralStatusIndicator
        status={status}
        overrideTooltipText={status ? StatusTooltipMap[status] : undefined}
    />
);
